import type { RfqSubmission, TimberSupplierInvite } from '../types';

export type PmQuoteInputActor = {
  uid: string;
  name: string;
};

export function stampPmQuoteInputAdjustment(actor: PmQuoteInputActor): Pick<
  RfqSubmission,
  'pmQuoteInputAdjustedAt' | 'pmQuoteInputAdjustedByUid' | 'pmQuoteInputAdjustedByName'
> {
  return {
    pmQuoteInputAdjustedAt: new Date(),
    pmQuoteInputAdjustedByUid: actor.uid,
    pmQuoteInputAdjustedByName: actor.name.trim() || 'Staff',
  };
}

export function pmQuoteInputAdjustedTitle(
  sub: Pick<RfqSubmission, 'pmQuoteInputAdjustedAt' | 'pmQuoteInputAdjustedByName'>,
): string {
  const name = (sub.pmQuoteInputAdjustedByName || '').trim() || 'Staff';
  const at = sub.pmQuoteInputAdjustedAt;
  if (at instanceof Date && !Number.isNaN(at.getTime())) {
    return `PM adjusted supplier quote input · ${name} · ${at.toLocaleString()}`;
  }
  return `PM adjusted supplier quote input · ${name}`;
}

export function submissionHasPmQuoteInputAdjustment(
  sub: Pick<RfqSubmission, 'pmQuoteInputAdjustedAt'>,
): boolean {
  return sub.pmQuoteInputAdjustedAt instanceof Date && !Number.isNaN(sub.pmQuoteInputAdjustedAt.getTime());
}

export function stampPmCncInviteInputAdjustment(actor: PmQuoteInputActor): Pick<
  TimberSupplierInvite,
  'pmCncInputAdjustedAtIso' | 'pmCncInputAdjustedByName'
> {
  return {
    pmCncInputAdjustedAtIso: new Date().toISOString(),
    pmCncInputAdjustedByName: actor.name.trim() || 'Staff',
  };
}

export function pmCncInviteInputAdjustedTitle(
  invite: Pick<TimberSupplierInvite, 'pmCncInputAdjustedAtIso' | 'pmCncInputAdjustedByName'>,
): string {
  const name = (invite.pmCncInputAdjustedByName || '').trim() || 'Staff';
  const raw = (invite.pmCncInputAdjustedAtIso || '').trim();
  if (raw) {
    const d = new Date(raw);
    if (!Number.isNaN(d.getTime())) {
      return `PM adjusted CNC quote request input · ${name} · ${d.toLocaleString()}`;
    }
  }
  return `PM adjusted CNC quote request input · ${name}`;
}

export function inviteHasPmCncInputAdjustment(
  invite: Pick<TimberSupplierInvite, 'pmCncInputAdjustedAtIso'>,
): boolean {
  const raw = (invite.pmCncInputAdjustedAtIso || '').trim();
  if (!raw) return false;
  return !Number.isNaN(new Date(raw).getTime());
}
